import { all, delay, put, takeEvery } from "redux-saga/effects";
import { hideMessage } from "../actions/Notification";
import { SHOW_MESSAGE } from "constants/ActionTypes";

function* hideMessageSaga(action) {
  try {
    yield delay(5000);
    yield put(hideMessage(action.payload.id));
  } catch (error) {}
}

function* workerSaga() {
  yield takeEvery(SHOW_MESSAGE, hideMessageSaga);
}

export default function* NotificationSaga() {
  yield all([workerSaga()]);
}
